export interface Article {
  slug: string;
  icon: string;
  image: string;
}

export const ARTICLES: Article[] = [
  {
    slug: "usfans-review",
    icon: "ri-star-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20modern%20minimal%20desk%20scene%20with%20a%20magnifying%20glass%20over%20product%20review%20notes%20and%20a%20star%20rating%20on%20paper%2C%20warm%20cream%20and%20sage%20green%20tones%2C%20soft%20natural%20light%2C%20clean%20editorial%20aesthetic%2C%20high%20detail&width=800&height=500&seq=article-review&orientation=landscape",
  },
  {
    slug: "shipping-cost",
    icon: "ri-truck-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20neat%20stack%20of%20cardboard%20shipping%20boxes%20with%20packing%20tape%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20clean%20logistics%20aesthetic%2C%20subtle%20shadows%2C%20high%20detail&width=800&height=500&seq=article-shipping-cost&orientation=landscape",
  },
  {
    slug: "warehouse-qc",
    icon: "ri-archive-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20bright%20modern%20warehouse%20interior%20with%20organized%20shelves%20of%20neatly%20folded%20clothing%20boxes%2C%20warm%20neutral%20tones%2C%20soft%20natural%20light%2C%20clean%20editorial%20aesthetic%2C%20high%20detail%2C%20no%20people&width=800&height=500&seq=article-warehouse-qc&orientation=landscape",
  },
  {
    slug: "coupon-discount",
    icon: "ri-coupon-2-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20flat%20lay%20of%20discount%20coupon%20cards%20and%20a%20shopping%20bag%20on%20a%20warm%20cream%20surface%20with%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20subtle%20shadows%2C%20clean%20fresh%20aesthetic%2C%20high%20detail&width=800&height=500&seq=article-coupon-discount&orientation=landscape",
  },
  {
    slug: "buying-guide",
    icon: "ri-shopping-bag-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20stylish%20shopping%20bag%20with%20a%20checklist%20and%20pen%20arranged%20on%20a%20warm%20cream%20desk%2C%20soft%20natural%20lighting%2C%20minimal%20editorial%20photography%2C%20clean%20fresh%20shopping%20aesthetic%2C%20subtle%20shadows%2C%20high%20detail&width=800&height=500&seq=article-buying-guide&orientation=landscape",
  },
  {
    slug: "safety-scam",
    icon: "ri-shield-check-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20shield%20icon%20and%20padlock%20concept%20arranged%20on%20a%20warm%20cream%20background%20with%20soft%20natural%20light%2C%20minimal%20abstract%20security%20theme%2C%20clean%20editorial%20aesthetic%2C%20subtle%20shadows%2C%20high%20detail&width=800&height=500&seq=article-safety-scam&orientation=landscape",
  },
  {
    slug: "alternatives",
    icon: "ri-arrow-left-right-line",
    image:
      "https://readdy.ai/api/search-image?query=Two%20balanced%20stacks%20of%20colorful%20product%20cards%20side%20by%20side%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20clean%20comparison%20aesthetic%2C%20subtle%20shadows%2C%20high%20detail&width=800&height=500&seq=article-alternatives&orientation=landscape",
  },
  {
    slug: "beginner-guide",
    icon: "ri-flag-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20neat%20beginner%20starter%20kit%20of%20folded%20clothing%20and%20a%20notebook%20on%20a%20warm%20cream%20desk%2C%20soft%20natural%20lighting%2C%20minimal%20editorial%20photography%2C%20clean%20fresh%20aesthetic%2C%20subtle%20shadows%2C%20high%20detail&width=800&height=500&seq=article-beginner-guide&orientation=landscape",
  },
  {
    slug: "shipping-methods",
    icon: "ri-route-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20delivery%20route%20map%20with%20location%20pins%20and%20a%20small%20parcel%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20minimal%20editorial%20photography%2C%20clean%20logistics%20aesthetic%2C%20high%20detail&width=800&height=500&seq=article-shipping-methods&orientation=landscape",
  },
  {
    slug: "faq-problems",
    icon: "ri-question-answer-line",
    image:
      "https://readdy.ai/api/search-image?query=Speech%20bubbles%20with%20question%20marks%20arranged%20on%20a%20warm%20cream%20background%20with%20soft%20natural%20light%2C%20minimal%20editorial%20abstract%20theme%2C%20clean%20fresh%20aesthetic%2C%20subtle%20shadows%2C%20high%20detail&width=800&height=500&seq=article-faq-problems&orientation=landscape",
  },
];